import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OfficialDocESignature from "./OfficialDocESignature";
import Tabs from "components/lib/Shared/Tabs";
import {
  checkOfficialHasUnsignedAppointmentDocs,
  checkOfficialHasUnsignedCessationDocs,
  checkOfficialHasUnsignedChangeOfParticularsDocs,
} from "utils/unsignedTransactionDocs";
import { ChevronLeftIcon, ChevronRightIcon } from "components/lib/Shared/Icons/sflIcons";

// Helper functions

const getOfficialsWithUnsignedDocs = (officials) => {
  return officials.filter(
    (official) =>
      checkOfficialHasUnsignedAppointmentDocs(official) ||
      checkOfficialHasUnsignedCessationDocs(official) ||
      checkOfficialHasUnsignedChangeOfParticularsDocs(official)
  );
};

const ChangeDocumentsEsignature = ({ goToPrevStep, handleConfirmDetails }) => {
  const transactionUnderReview = useSelector(
    (state) => state.transactionSlice.transactionUnderReview
  );

  const officialsWithUnsignedDocs = getOfficialsWithUnsignedDocs(
    transactionUnderReview.items.officials
  );

  const tabs = officialsWithUnsignedDocs.map((official, index) => ({
    label: `Official ${index + 1}`,
    id: index,
  }));

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const selectedTab = tabs[selectedTabIndex];
  const isLastStep = selectedTabIndex === tabs.length - 1;

  const goToNextStep = () => {
    setSelectedTabIndex((current) =>
      current < tabs.length - 1 ? current + 1 : current
    );
  };

  const goBack = () => {
    if (selectedTabIndex === 0) {
      goToPrevStep();
    } else {
      setSelectedTabIndex((current) => current - 1);
    }
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Officials Change Documents</h2>
      <Tabs
        tabs={tabs}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
      />

      <div>
        {officialsWithUnsignedDocs?.length > 0 &&
          officialsWithUnsignedDocs.map((official, index) => {
            if (selectedTabIndex === index) {
              return (
                <OfficialDocESignature
                  key={official.id || index}
                  official={official}
                  isLastStep={isLastStep}
                  handleConfirmDetails={handleConfirmDetails}
                  goToNextStep={goToNextStep}
                />
              );
            }
            return null;
          })}
      </div>

      <div className="flex justify-between">
        <div>
          <button
            onClick={goBack}
            className="flex items-start float-left py-2 font-semibold rounded text-primary mt-7"
          >
            <span className="flex items-center mr-4 h-7">
              <ChevronLeftIcon
                className="flex-shrink-0 w-5 h-5"
                aria-hidden="true"
              />
            </span>
            <p className="font-semibold">Go back</p>
          </button>
        </div>

        {tabs.length > 1 && !isLastStep && (
          <div>
            <button
              onClick={goToNextStep}
              className="flex items-start float-left py-2 font-semibold rounded text-primary mt-7"
            >
              <p className="font-semibold">Next Step</p>
              <span className="flex items-center mr-4 h-7">
                <ChevronRightIcon
                  className="flex-shrink-0 w-5 h-5"
                  aria-hidden="true"
                />
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangeDocumentsEsignature;
